import React, {
	useEffect,
	useState,
	forwardRef,
	useImperativeHandle,
} from "react";
import _ from "lodash";
import { inputValidationChecks } from "../../../utils/formValidation";

const Input = forwardRef((props, ref) => {
	const {
		val,
		setVal,
		label = "",
		placeholder = "",
		classInput = "",
		classLabel = "",
		validation = "",
	} = props;

	useImperativeHandle(ref, () => {
		return {
			validateInput: validateInput,
		};
	});

	const [submitted, setSubmitted] = useState(false);
	const [error, setError] = useState("");

	const handleUserInput = (e) => {
		setVal(e.target.value);
		if (submitted) {
			validateInput(e.target.value);
		}
	};

	const validateInput = (value = null) => {
		let errors = false;
		if (value) {
			errors = inputValidationChecks(value, validation, setError);
		} else {
			errors = inputValidationChecks(val, validation, setError);
			setSubmitted(true);
		}
		return errors;
	};

	return (
		<>
			<label htmlFor="formGroupExampleInput" className={classLabel}>
				{label}
			</label>
			<input
				type="text"
				className={classInput + `${error === "" ? "" : " is-invalid"}`}
				placeholder={placeholder}
				value={val}
				onChange={(e) => handleUserInput(e)}
			/>
			{error && <div className="invalid-feedback">{error}</div>}
		</>
	);
});

export default Input;
